module.exports = __webpack_public_path__ + "img/77ne.98b57626.svg";